import { Component, OnInit } from '@angular/core';
import { SharedDataService } from 'ngx-paf-common';
import { AuthenticationService } from 'src/app/SERVICES/authentication.service';

@Component({
  selector: 'openid-logout',
  templateUrl: './openid-logout.component.html',
  styleUrls: ['./openid-logout.component.scss']
})
export class OpenidLogoutComponent implements OnInit {

  constructor(
    public authService: AuthenticationService,
    public sharedDatas: SharedDataService) { }

  ngOnInit(): void {
  }

}
